import React, { useLayoutEffect, useRef } from "react";

// Note: The props should consist of 2 children
// Left Pane Child: This will be the form
// Right Pane Child: This is the chat area
// See AskLitchartsAI.jsx to see this in use.

const AIToolsLayout = ({ children, dataTestId = "AIToolsLayout" }) => {
  const layoutRef = useRef();
  const resizeHandler = () => {
    const layoutBanner = document.querySelector("body > .lc-banner");
    const panelBanner = document.querySelector("#panel > .lc-banner");
    const promoBanner = document.querySelector("#sticky-mobile-header-promo");
    const header = document.querySelector(".header");
    const layoutBannerHeight = layoutBanner?.offsetHeight || 0;
    const panelBannerHeight = panelBanner?.offsetHeight || 0;
    const promoBannerHeight = promoBanner?.offsetHeight || 0;
    const headerHeight = header.offsetHeight;

    const offset =
      headerHeight + layoutBannerHeight + panelBannerHeight + promoBannerHeight;

    layoutRef.current.style.height = `calc(100dvh -  ${offset}px)`;
  };
  useLayoutEffect(() => {
    resizeHandler();

    window.addEventListener("resize", resizeHandler);
    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);
  return (
    <div className="ai-tools--layout" data-testid={dataTestId} ref={layoutRef}>
      <div className="ask-litcharts-ai--container">
        <div className="ask-litcharts-ai--form">{children[0]}</div>
        <div className="ask-litcharts-ai--chat_area">{children[1]}</div>
      </div>
    </div>
  );
};

export default AIToolsLayout;
